@if (!data.showDesc) {
  <div class="mood-dialog">
    <div class="mood-dialog__header">
      <h2 class="mood-dialog__title">{{ 'rateMoodText' | translate: translations }}</h2>
      <p class="mood-dialog__subtitle">{{ 'rateMoodDailyText' | translate: translations }}</p>
    </div>
    <div mat-dialog-content class="mood-dialog__content">
      <div class="mood-dialog__scale" role="radiogroup" [attr.aria-label]="'rateMoodText' | translate: translations">
        @for (mood of moods; track mood) {
          <button
            type="button"
            class="mood-dialog__scale-btn"
            [class.mood-dialog__scale-btn--selected]="selectedMoodId === mood.id"
        [ngStyle]="{
          'background-color': mood.description,
          color: mood.id <= 5 ? '#fff' : '#1d002f'
        }"
            (click)="getMoodValue(mood)">
            {{ mood.id }}
          </button>
        }
      </div>
      <div class="mood-dialog__legend">
        <span><strong>1</strong> — {{ 'extremelyPoorText' | translate: translations }}</span>
        <span><strong>5</strong> — {{ 'neutralText' | translate: translations }}</span>
        <span><strong>10</strong> — {{ 'extremelyGoodText' | translate: translations }}</span>
      </div>
      <label class="mood-dialog__journal-label" for="mood-journal-input">
        {{ 'userSpaceText' | translate: translations }}
      </label>
      <textarea
        id="mood-journal-input"
        class="mood-dialog__journal"
        rows="4"
      [(ngModel)]="selectedMood.moodJournal"></textarea>
    </div>
    <div mat-dialog-actions class="mood-dialog__actions">
      <button
        type="button"
        class="mood-dialog__btn mood-dialog__btn--primary"
        [mat-dialog-close]="selectedMood">
        {{ 'saveButtonText' | translate: translations }}
      </button>
      <button
        type="button"
        class="mood-dialog__btn mood-dialog__btn--secondary"
        (click)="onNoClick()">
        {{ 'cancelButtonText' | translate: translations }}
      </button>
    </div>
  </div>
}

@if (data.showDesc) {
  <div class="mood-dialog mood-dialog--view">
    <div class="mood-dialog__header">
      <p class="mood-dialog__eyebrow">{{ data.date | date: 'MMMM d' }}</p>
      <h2 class="mood-dialog__title">{{ 'journalEntryText' | translate: translations }}</h2>
    </div>
    <div mat-dialog-content class="mood-dialog__content">
      <div class="mood-dialog__entry">
        <span
          class="mood-dialog__entry-score"
        [ngStyle]="{
          'background-color': data.moodColor,
          color: data.moodId <= 5 ? '#fff' : '#1d002f'
        }">
          {{ data.moodId }}
        </span>
        <p class="mood-dialog__entry-text">{{ data.desc || '—' }}</p>
      </div>
    </div>
    <div mat-dialog-actions class="mood-dialog__actions mood-dialog__actions--single">
      <button type="button" class="mood-dialog__btn mood-dialog__btn--primary" (click)="onNoClick()">
        {{ 'closeButtonText' | translate: translations }}
      </button>
    </div>
  </div>
}
